/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_TitleInputs */



/**
* | output |
* | --- |
* | "File Import" |
*
* @param {File_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_title = /** @type {((inputs?: File_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("File Import")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateiimport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт файлов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de archivos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルのインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de Arquivos")
	return /** @type {LocalizedString} */ ("File Import")
});